// Pack mutations and queries used in more than one place
import { gql } from 'apollo-boost';

export const GET_PACKS_QUERY = gql`
query packs {
    packs {
        id
        name
    }
}
`;

export const GET_BOOK_TYPES_QUERY = gql`
query bookTemplateCategories($hidden: Boolean) {
    bookTemplateCategories(hidden: $hidden) {
        id
        name
        backgroundColor
        textColor
        iconUrl
        description
        hidden
        subcategories {
            id
            name
            backgroundColor
            textColor
            iconUrl
            description
            hidden
        }
    }
}
`;


export const GET_SUBCATEGORIES = gql`
query bookTemplateSubcategories($parentId: ID! $hidden: Boolean) {
    bookTemplateSubcategories(parentId: $parentId hidden: $hidden) {
        id
        name
        backgroundColor
        textColor
        iconUrl
        description
        hidden

    }
}
`;


export const GET_S3_UPLOAD_QUERY = gql`
query s3UploadUrlFor($name: String, $fileType: String, $object: String!) {
    s3UploadUrlFor(name: $name, fileType: $fileType, object: $object) {
        name
        uploadUrl
    }
}
`;